import api, { ApiResponse, PageResponse } from './api'
import type { Order, Refund, RefundRequest } from '../types'

interface OrderListParams {
  page?: number
  size?: number
  orderId?: string
  checkoutId?: string
  customerEmail?: string
  status?: string
  productId?: string
  startDate?: number
  endDate?: number
}

export function getOrders(params: OrderListParams): Promise<ApiResponse<PageResponse<Order>>> {
  return api.get('/v1/merchant/orders', { params })
}

export function getOrder(id: string): Promise<ApiResponse<Order>> {
  return api.get(`/v1/merchant/orders/${id}`)
}

export interface IssueOrderInvoiceRequest {
  recipientName: string
  recipientAddress: string
  recipientEmail?: string
}

export function issueOrderInvoice(id: string, data: IssueOrderInvoiceRequest): Promise<Blob> {
  return api.post(`/v1/merchant/orders/${id}/invoice`, data, { responseType: 'blob' })
}

export function downloadOrderInvoice(id: string): Promise<Blob> {
  return api.get(`/v1/merchant/orders/${id}/invoice`, { responseType: 'blob' })
}

export function exportOrders(startDate: number, endDate: number): Promise<Blob> {
  return api.get('/v1/merchant/orders/export', {
    params: { startDate, endDate },
    responseType: 'blob'
  })
}

export function getOrderRefunds(orderId: string): Promise<ApiResponse<Refund[]>> {
  return api.get(`/v1/merchant/orders/${orderId}/refunds`)
}

export function getOrderRefundRequests(orderId: string): Promise<ApiResponse<RefundRequest[]>> {
  return api.get(`/v1/merchant/orders/${orderId}/refund-requests`)
}

export function createRefundRequest(
  orderId: string,
  data: { amount: string; reason: string }
): Promise<ApiResponse<RefundRequest>> {
  return api.post(`/v1/merchant/orders/${orderId}/refund-requests`, data)
}
